import { accordionAnatomy } from '@chakra-ui/anatomy';
import { createMultiStyleConfigHelpers, defineStyle, } from '@chakra-ui/styled-system';
import { ThemeBorderVariable, ThemeColorVariable, ThemeFontSizeVariable, ThemeRadiusVariable, ThemeSpaceVariable, } from '../../theme-types';
const { definePartsStyle, defineMultiStyleConfig } = createMultiStyleConfigHelpers(accordionAnatomy.keys);
// Common styles
const baseRootStyle = defineStyle({
    width: '100%',
});
const baseButtonStyle = defineStyle({
    display: 'flex',
    width: '100%',
    fontSize: ThemeFontSizeVariable.Large,
    fontWeight: '500',
    py: ThemeSpaceVariable.Small,
    px: ThemeSpaceVariable.Medium,
    '@media(hover: hover)': {
        _hover: {
            background: ThemeColorVariable.SurfaceDisabled,
        },
    },
});
const basePanelStyle = defineStyle({
    width: '100%',
    padding: ThemeSpaceVariable.Medium,
    color: ThemeColorVariable.OnSurface,
});
// Variants
const borderVariant = definePartsStyle({
    button: {
        color: ThemeColorVariable.OnSurface,
        background: ThemeColorVariable.Surface,
        borderRadius: ThemeRadiusVariable.Medium,
        justifyContent: 'space-between',
        _expanded: {
            borderBottom: ThemeBorderVariable.XSmall,
            borderColor: ThemeColorVariable.OnSurfaceBorder,
            borderBottomRadius: ThemeRadiusVariable.None,
        },
        ...baseButtonStyle,
    },
    container: {
        border: 'none',
    },
    root: {
        background: ThemeColorVariable.Surface,
        borderRadius: ThemeRadiusVariable.Medium,
        border: ThemeBorderVariable.XSmall,
        borderColor: ThemeColorVariable.OnSurfaceBorder,
        ...baseRootStyle,
    },
    panel: {
        ...basePanelStyle,
    },
});
const noBorderVariant = definePartsStyle({
    button: {
        ...baseButtonStyle,
        color: ThemeColorVariable.OnBackground,
        flexDirection: 'row-reverse',
        justifyContent: 'flex-end',
        gap: ThemeSpaceVariable.XSmall,
        '@media(hover: hover)': {
            _hover: {
                background: ThemeColorVariable.SurfaceDisabled,
                borderRadius: ThemeRadiusVariable.Medium,
            },
        },
        _expanded: {
            borderBottomRadius: ThemeRadiusVariable.None,
        },
    },
    container: {
        border: 'none',
    },
    root: {
        background: 'transparent',
        // Root has no expanded state on its own, we identify the state via the button
        ':has(button[aria-expanded="true"])': {
            borderRadius: ThemeRadiusVariable.Medium,
            border: ThemeBorderVariable.XSmall,
            borderColor: ThemeColorVariable.OnSurfaceBorder,
        },
        ...baseRootStyle,
    },
    panel: {
        pt: 0,
        px: ThemeSpaceVariable.Medium,
        pb: ThemeSpaceVariable.Medium,
        color: ThemeColorVariable.OnBackground,
        width: '100%',
    },
});
const listVariant = definePartsStyle({
    button: {
        color: ThemeColorVariable.OnSurface,
        background: 'transparent',
        justifyContent: 'space-between',
        ...baseButtonStyle,
    },
    container: {
        borderTopWidth: 0,
        borderBottom: ThemeBorderVariable.XSmall,
        borderBottomColor: ThemeColorVariable.OnSurfaceBorder,
        '&:last-child': {
            borderBottom: 'none',
        },
    },
    root: {
        background: ThemeColorVariable.Surface,
        border: 'none',
        ...baseRootStyle,
    },
    panel: {
        ...basePanelStyle,
    },
});
export const accordionConfig = defineMultiStyleConfig({
    variants: {
        border: borderVariant,
        noBorder: noBorderVariant,
        list: listVariant,
    },
    defaultProps: {
        variant: 'border',
    },
});
//# sourceMappingURL=accordion-theme.js.map